module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00457.76bea1d5.jpg";